<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <!-- <div class="vx-col md:w-full flex items-center mb-5">
                <TitleScreen></TitleScreen>
            </div> -->
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.class') }}</label>
                    <v-select class="" v-model="selectedClass" :clearable="false" :options="classOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.student') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="studentOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.time') }}</label>
                    <!-- <div class="flex-grow"> -->
                    <date-range-picker
                        ref="picker" class="w-full"
                        :locale-data="{format: 'dd/mm/yyyy' }"
                        :opens="'left'"
                        @update="dateRangePicker"
                        v-model="dateRange">
                    </date-range-picker>
                    <!-- </div> -->
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.device') }}</label>
                    <v-select class="" v-model="selectedDevice" :clearable="false"
                              :options="deviceOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <div v-if="this.selectedDevice.value === 'camera'">
                        <label class="vs-input--label">{{ $t('menuHistory.selectCamera') }}</label>
                        <v-select class="" v-model="selectedCamera" :clearable="false"
                                  :options="cameraOptions">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                    <div v-if="this.selectedDevice.value === 'pad'">
                        <label class="vs-input--label">{{ $t('menuEvent.selectPad') }}</label>
                        <v-select class="" v-model="selectedPad" :clearable="false"
                                  :options="padsData">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </div>

                <div class="vx-col md:w-1/2 w-full mt-26">
                    <vs-button class="float-right" icon-pack="feather" icon="icon-search" @click="search">
                        {{ $t('menuHistory.filter') }}
                    </vs-button>
                    <!-- <vs-button class="mr-5 float-right" @click="exportFile" :disabled="!validateForm" v-if="isPermissionExport()">
                        {{ $t('menuHistory.createReport') }}
                    </vs-button> -->
                </div>

                <!--                <div class="vx-col md:w-1/4 w-full mt-8">-->
                <!--                    <vs-input class="w-full" v-model="searchQuery" @input="updateSearchQuery"-->
                <!--                              :placeholder="$t('button.search')"/>-->
                <!--                </div>-->

            </div>
            <!-- <div class="flex flex-wrap items-center mt-4">
                <div class="flex-grow"></div>
                <vs-input class="" v-model="searchQuery" @input="updateSearchQuery" :placeholder="$t('button.search')"/>
            </div> -->
            <!-- AgGrid Table -->
            <div class="custom-table-inout">
                <ag-grid-vue style=""
                             ref="agGridTable"
                             :gridOptions="gridOptions"
                             class="ag-theme-material w-100 my-4 ag-grid-table"
                             :columnDefs="columnDefs"
                             :defaultColDef="defaultColDef"
                             :rowData="workShiftData"
                             :animateRows="true"
                             :onGridReady="onGridReady"
                             :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                             :autoSizeStrategy="autoSizeStrategy"
                             tooltipShowDelay="0"
                             tooltipHideDelay="5000">
                </ag-grid-vue>
            </div>


            <div class="mt-4 flex flex-wrap" v-if="workShiftData.length > 0">
                <div class="">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 flex flex-wrap">
                        <span class="my-auto mr-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        workShiftData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : workShiftData.length
                                    }} / {{ totalElements }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="setPageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(40)">
                                    <span>40</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(60)">
                                    <span>60</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(80)">
                                    <span>80</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="ml-auto">
                    <vs-pagination class="" :total="totalPages" v-model="currentPage" @change="changePage"/>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>
.vue-daterange-picker .ranges {
    float: right;
    border-left: 1px solid #ddd;
}

.daterangepicker {
    border-left: none !important;
}

.title-page {
    font-size: 2.2rem;
    font-weight: bold;
    display: flex;
}

.text-font {
    opacity: 0.7;
}

.reportrange-text {
    border-radius: 5px;
    height: 38px;
    line-height: 27px;
}

.mt-26 {
    margin-top: 26px;
}

.grid-cell-centered {
    text-align: center;
    justify-content: center;
}
</style>

<style lang="scss">
.custom-table-inout .ag-theme-material .ag-ltr .ag-cell {
    line-height: 100px;
}
</style>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'; // Vuesax
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Pagination from "../../ui-elements/Pagination.vue"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import CellRendererImg from "../confirmTimeKeeping/cell-renderer/CellRendererImg"
import CellRendererDataAI from "./cell-renderer/CellRendererDataAI"
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
// import TitleScreen from "../../../layouts/main/TitleScreen";

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        CellRendererActions,
        Pagination,
        flatPickr,
        CellRendererImg,
        DateRangePicker,
        CellRendererDataAI,
        // TitleScreen
    },
    data() {
        return {
            showImg: false,
            imageUrl: "",
            searchQuery: "",
            // AgGrid
            gridApi: null,
            gridOptions: {
                rowHeight: 70
            },
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuHistory.studentCode'),
                    field: 'studentCode',
                    width: 70,
                },
                {
                    headerName: this.$t('menuHistory.studentName'),
                    field: 'fullName',
                    width: 160
                },
                {
                    headerName: this.$t('menuHistory.class'),
                    field: 'className',
                    width: 160
                },
                {
                    headerName: this.$t('menuHistory.device'),
                    field: 'deviceType',
                    width: 100,
                },
                {
                    headerName: this.$t('menuHistory.deviceName'),
                    field: 'cameraName',
                    width: 150,
                },
                {
                    headerName: this.$t('menuHistory.img'),
                    field: 'imageUrl',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                },
                {
                    headerName: this.$t('menuHistory.time'),
                    field: 'checkinTime',
                    width: 150,
                }
            ],
            studentData: [],
            workShiftData: [],
            organizationBranchOptions: [],
            studentOptions: [
                {value: null, label: this.$t('menuHistory.all')}
            ],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            cameraOptions: [{value: null, label: this.$t('menuHistory.all')}],
            padsData: [{value: null, label: this.$t('menuHistory.all')}],
            deviceOptions: [
                {value: null, label: this.$t('menuHistory.all')},
                {value: 'camera', label: "Camera"},
                {value: 'pad', label: "Pad"},
            ],
            deviceId: null,
            cameraId: null,
            padId: null,
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            classData: [],
            classOptions: [],
            classId: null,
            pageSize: 20,
            pageNumber: 0,
            totalElements: 0,
            currentPage: 1,
            totalPages: 0,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
        }
    },
    created() {
        this.selectedEmployeeValue = this.$route.query.employeeId ? parseInt(this.$route.query.employeeId) : null;
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        selectedCamera: {
            get() {
                if (this.cameraOptions.length > 0) {
                    return {
                        label: this.cameraOptions.find(x => x.value == this.cameraId).label,
                        value: this.cameraId
                    }
                }
            },
            set(obj) {
                this.cameraId = obj.value
            }
        },
        selectedPad: {
            get() {
                if (this.padsData.length > 0) {
                    return {
                        label: this.padsData.find(x => x.value == this.padId).label,
                        value: this.padId
                    }
                }
            },
            set(obj) {
                this.padId = obj.value
            }
        },

        selectedDevice: {
            get() {
                if (this.deviceOptions.length > 0) {
                    return {
                        label: this.deviceOptions.find(x => x.value == this.deviceId).label,
                        value: this.deviceId
                    }
                }
            },
            async set(obj) {
                this.deviceId = obj.value
                if (this.deviceId === 'camera') {
                    await this.getCameraByBranch();
                    this.selectedCamera = this.cameraOptions[0];
                }
                if (this.deviceId === 'pad') {
                    await this.getHardwareDevice();
                    this.selectedPad = this.padsData[0];
                }
                if (!this.deviceId) {
                    this.cameraId = null;
                    this.padId = null;
                }
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null;
                await this.getClassData()
                await this.loadStudent();
                await this.getHardwareDevice();
                await this.getCameraByBranch()
                this.selectedDevice = this.deviceOptions[0]
                this.selectedCamera = this.cameraOptions[0]
                this.selectedPad = this.padsData[0]
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
        selectedClass: {
            get() {
                let obj = this.classOptions.find(x => x.value == this.classId)
                if (!obj) return
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.classId = obj ? obj.value : null;
                await this.loadStudent();
            }
        }
    },
    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        getHardwareDevice() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                let data = {
                    organizationBranchId: this.selectedOrganizationBranchValue
                }
                this.padsData = [];
                this.$str.post('/device/find-by-condition', data).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.padsData = res.data.content.map(item => {
                            return {value: item.id, label: item.deviceName}
                        });
                    }
                    this.padsData.unshift({value: null, label: this.$t('menuHistory.all')})
                    this.$vs.loading.close()
                    resolve()
                }).catch(err => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })

        },
        getCameraByBranch() {
            return new Promise((resolve, reject) => {
                let that = this;
                let url = this.selectedOrganizationBranchValue ? `/camera/find-by-organization-branch/${this.selectedOrganizationBranchValue}` : `/camera/all`
                that.$vs.loading();
                that.$crm.post(url).then((response) => {
                    that.cameraOptions = response.data.map(item => {
                        return {value: item.id, label: item.cameraName}
                    });
                    that.cameraOptions.unshift({value: null, label: this.$t('menuHistory.all')})
                    that.$vs.loading.close();
                    resolve()
                }).catch((err) => {
                    that.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })

        },
        getClassData() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                let payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                }
                this.$crm.post('/school-classroom/get-all-class', payload).then(res => {
                    this.classData = res.data;
                    if (res.data && res.data.length > 0) {
                        this.classOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.className
                            }
                        })
                    } else {
                        this.classOptions = [];
                    }
                    this.classOptions.unshift({value: null, label: this.$t('menuHistory.all')})
                    resolve()
                    this.$vs.loading.close()
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        mouseOver: function () {
            this.active = !this.active;
        },
        // updateSearchQuery(val) {
        //     this.gridApi.setGridOption('quickFilterText', val);
        // },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuHistory.determine');
        },
        employeeString(id) {
            let employee = this.studentOptions.find(x => x.value === id);
            return (employee && employee.label) || this.$t('menuHistory.undefined');
        },
        validateForm() {
            return !this.errors.any()
        },
        filter() {
            let searchInfo = {
                deviceType: this.deviceId,
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                cameraId: this.deviceId == this.deviceOptions[1].value ? this.cameraId : this.padId,
                start: this.dateRange.startDate,
                end: this.dateRange.endDate
            }
            let that = this;
            that.$crm.post('/time-keeping/all-in-out-org', searchInfo).then((response) => {
                if (response.data && response.data.content.length > 0) {
                    that.workShiftData = response.data.content.map(res => {
                        // if (res.organizationBranchId != that.selectedOrganizationBranchValue) return;
                        let student = that.studentData.find(stu => stu.id == res.employeeId);
                        if (student) {
                            res.classId = student.classIds[0];
                            res.className = student.className;
                            res.studentCode = student.studentCode;
                            res.fullName = student.fullName;
                            res.cameraName = '';
                            if (res.deviceType == this.deviceOptions[1].value) {
                                let camera = this.cameraOptions.find(x => x.value == res.cameraId);
                                res.cameraName = camera ? camera.label : '';
                                res.deviceType = res.deviceType.toUpperCase();
                            } else if (res.deviceType == this.deviceOptions[2].value) {
                                let pad = this.padsData.find(x => x.value == res.cameraId);
                                res.cameraName = pad ? pad.label : '';
                                res.deviceType = res.deviceType.toUpperCase();
                            }
                            return res;
                        }
                    })

                    that.workShiftData = that.workShiftData.filter(x => x != undefined);

                    if (that.classId) {
                        that.workShiftData = that.workShiftData.filter(x => x.classId == that.classId)
                    }

                    that.workShiftData.forEach(x => {
                        x.checkinTime = x.createdAt ? moment(x.createdAt).format("DD/MM/YYYY HH:mm:ss") : null;
                        if (!x.imageUrl.match('http')) {
                            x.imageUrl = authConfig.processorDomain + "storage/" + x.imageUrl
                        }
                    });
                } else {
                    that.workShiftData = [];
                }
                that.$vs.loading.close();
            }).catch((err) => {
                console.log(err)
            });
        },
        exportFile() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                start: this.dateRange.startDate,
                end: this.dateRange.endDate
            };

            this.$vs.loading();
            this.$crm.post('/time-keeping/create-in-out-org', searchInfo).then((response) => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) return;
            this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            })
            this.organizationBranchOptions.unshift({value: null, label: this.$t('menuIntrusion.all')})

            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            await this.getClassData()
            await this.loadStudent();
            // await this.getHardwareDevice();
            // await this.getCameraByBranch()
            this.filter();
        },
        loadStudent() {
            // if (!this.selectedOrganizationBranchValue) return;
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let employeeSearchDTO = {
                    enabled: true,
                    classId: this.classId,
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    pageNumber: 0,
                    pageSize: 100,
                }
                this.$crm.post(`/school-student/find-by-organization-branch`, employeeSearchDTO).then((response) => {
                    this.studentData = response.data.map(x => {
                        let result = this.classData.find(el => el.id == x.classIds[0])
                        if (result) {
                            x.className = result.className
                        }
                        return x
                    });
                    this.studentOptions = response.data.map(item => {
                        return {
                            value: item.id,
                            label: item.studentCode + " " + item.fullName
                        }
                    });
                    this.studentOptions.unshift({value: null, label: this.$t('menuHistory.all')})

                    this.$vs.loading.close();
                    resolve()
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })

        },

        search() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.filter();
        },

        changePage: function (currentPage) {
            if (this.pageNumber !== (parseInt(currentPage) - 1)) {
                this.pageNumber = parseInt(currentPage) - 1;
                this.filter();
            }
        },

        setPageSize(e) {
            this.pageSize = e;
            this.search();
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>
